import React from 'react'

import BarChart from './BarChart'

export default function Bar() {
  return(
    <BarChart bardash={false} />
  )
}
